'use strict';

/**
 * Amazing Nature — bundle cards add to the cart instead of jumping to checkout.
 *
 * The bundle CTA in sections/bundle-teaser.liquid links to a Shopify cart
 * permalink (/cart/<variant>:<qty>,<variant>:<qty>?discount=<CODE>). Followed
 * as a plain link, that permalink REPLACES the visitor's cart and drops them
 * straight into checkout (order summary collapsed on mobile).
 *
 * This script intercepts the click, adds the bundle items to the existing
 * cart, applies the bundle discount code (keeping codes already on the cart)
 * and opens the cart drawer. If anything fails, it falls back to the original
 * link, so the bundle can always be bought.
 */
(() => {
  function parseBundle(href) {
    const match = href.match(/^\/cart\/([0-9:,]+)(?:\?(.*))?$/);
    if (!match) return null;
    const items = match[1].split(',').map(part => {
      const pieces = part.split(':');
      return { id: Number(pieces[0]), quantity: Number(pieces[1]) || 1 };
    }).filter(item => item.id > 0);
    if (!items.length) return null;
    const code = new URLSearchParams(match[2] || '').get('discount') || '';
    return { items, code };
  }

  function request(url, body) {
    const options = { headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(resp => {
      if (!resp.ok) throw new Error(url + ' ' + resp.status);
      return resp.json();
    });
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest('.bt-card a.btn');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;

    const bundle = parseBundle(link.getAttribute('href') || '');
    if (!bundle) return;

    event.preventDefault();
    if (link.dataset.busy) return;
    link.dataset.busy = '1';
    link.setAttribute('aria-busy', 'true');

    try {
      await request('/cart/add.js', { items: bundle.items });
      let cart = await request('/cart.js');

      if (bundle.code) {
        const codes = (cart.discount_codes || []).map(entry => entry.code);
        if (codes.indexOf(bundle.code) === -1) codes.push(bundle.code);
        cart = await request('/cart/update.js', { discount: codes.join(',') });
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (error) {
      console.error('Bundle add failed, falling back to link:', error);
      window.location.href = link.href;
    } finally {
      delete link.dataset.busy;
      link.removeAttribute('aria-busy');
    }
  });
})();
